import React, { useContext, useEffect, useRef } from 'react';
import { MobXProviderContext } from 'mobx-react';

import Guideline from '../tools/Guideline';
import HtmlComponent from '../HtmlComponent';
import useStyleEvents from '../../../hooks/useStyleEvents';

import AuthService from '../../services/AuthService';
import '../../../css/MicrositeQuestion.scss';

const MicrositeQuestion = ({ lessonElementId }) => {
  const {
    lessonManager,
    toolbarManager,
    studentActivityManager,
    responseManager,
  } = useContext(MobXProviderContext);

  const model = lessonManager.getSlideModel(lessonElementId);
  const iframeRef = useRef(null);

  useStyleEvents(lessonElementId, `${lessonElementId}-microsite-view`);

  // Construct the microsite URL using redirectToMicrosite API
  const micrositeUrl = (() => {
    if (!model?.micrositeEntityId) return '';
    const params = new URLSearchParams({
      resourceId: model.micrositeEntityId,
      authKey: AuthService.authKey,
    });
    if (studentActivityManager?.activityId) {
      params.set('activityId', studentActivityManager.activityId);
    }
    const activityResponseId = responseManager?.getLessonElementState(lessonElementId)?.responseId;
    if (activityResponseId) {
      params.set('activityResponseId', activityResponseId);
    }
    const url = `${AuthService.ecms}/api/redirectToMicrosite?${params.toString()}`;
    console.log('Microsite URL ids:', {
      resourceId: model.micrositeEntityId,
      activityId: studentActivityManager?.activityId ?? null,
      activityResponseId: activityResponseId ?? null,
    });
    return url;
  })();

  // Handle iframe load event and execute loadEventScript
  const handleIframeLoad = () => {
    if (model?.loadEventScript && iframeRef.current) {
      try {
        // Execute the loadEventScript as JavaScript
        // Using Function constructor for safer execution context
        const executeScript = new Function(model.loadEventScript);
        executeScript();
      } catch (error) {
        console.error('Error executing loadEventScript:', error);
      }
    }
  };

  useEffect(() => {
    const iframe = iframeRef.current;
    if (iframe) {
      iframe.addEventListener('load', handleIframeLoad);
      return () => {
        iframe.removeEventListener('load', handleIframeLoad);
      };
    }
  }, [lessonElementId, model?.loadEventScript]);

  return (
    <div className='microsite-question' id={`${lessonElementId}-microsite-view`}>
      {toolbarManager.isGuidelineOpen && <Guideline lessonElementId={lessonElementId} />}
      <div className='test-item-question lesson-element microsite-question-container'>
        {model?.questionText && (
          <div className='microsite-question-text'>
            <HtmlComponent htmlStr={model.questionText} />
          </div>
        )}
        {micrositeUrl && (
          <div className='microsite-iframe-container'>
            <iframe
              ref={iframeRef}
              key={lessonElementId}
              allowFullScreen={true}
              id={`${lessonElementId}-microsite-iframe`}
              src={micrositeUrl}
              title={model.title || 'Microsite'}
              className='microsite-iframe'
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default MicrositeQuestion;


